import { Component } from "@angular/core";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'unit-two-lesson-five-guide',
    templateUrl: './_guide.component.html',
    styleUrls: ['../../_shared/lesson-guides/lesson-guide.component.css']
})
export class UnitTwoLessonFiveGuideComponent {

    pageTitle: string = "Lesson Guide | Unit 2, Lesson 5 | T-Folio";
    title: string = "Lesson Guide";
    subtitle: string = "Lesson 5: Writing Your Course of Study";

    public constructor(private titleService: Title) {
        this.titleService.setTitle(this.pageTitle);
    }
}
